
import Vue from 'vue';
import { Data as AuthorData } from '@root/modules/author/types/author';
import ContentImage from '@core/components/UI/ContentImage.vue';
import { CustomCrop, Focuspoint } from '@root/common/types/fragment';

interface Props {
  author: AuthorData;
  width: number;
  height: number;
}

interface Computed {
  cropperData: Record<string, any>;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    ContentImage,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cropperData() {
      const cropperData: any = { xs: { w: this.width, h: this.height } };

      const customCrop: CustomCrop | null = this.author?.image?.attributes.cropperData?.customCrops?.find((item: CustomCrop) => item.ratio === '1:1') || null;
      if (customCrop) {
        cropperData.customCrop = customCrop;
      }

      const focuspoint: Focuspoint | undefined = this.author?.image?.attributes.cropperData?.focuspoint;
      cropperData.xs.fx = focuspoint?.x || 0.5;
      cropperData.xs.fy = focuspoint?.y || 0.25;

      return cropperData;
    },
  },
});
